export const evaluateRule = (rule, context) => {
  if (!rule) return false;

  if (rule.field) {
    if (rule.equals !== undefined) return context[rule.field] === rule.equals;
    if (rule.lessThan !== undefined) return context[rule.field] < rule.lessThan;
    if (rule.greaterThan !== undefined)
      return context[rule.field] > rule.greaterThan;
  }

  if (rule.anyOf) return rule.anyOf.some((r) => evaluateRule(r, context));
  if (rule.allOf) return rule.allOf.every((r) => evaluateRule(r, context));

  return false;
};
